import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SupportCenterService } from './support-center.service';
import { ProductService } from '@shared/services/product/product.service';
import { filter, take } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SupportCenterResolverService {
  constructor(
    private supportCenterService: SupportCenterService,
    private productService: ProductService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state?: RouterStateSnapshot): void {
    this.supportCenterService.resetSupportCenterContent();
    this.supportCenterService.loadSupportCenterContent();
    this.supportCenterService
      .getProductsToLoad$()
      .pipe(
        filter(support => support.isLoaded),
        take(1),
      )
      .subscribe(support => {
        this.productService.loadProducts(support.products);
      });
  }
}
